<template>
    <div ref="printSection" v-if="mouEffectivenessCard" class="w-full mx-auto box-border" style="min-width: 210mm;">
        <table class="w-full border border-black border-collapse">
            <tbody>
                <tr>
                    <th colspan="3" class="font-bold text-center t-heading text-black p-3 border border-black">
                        <div class="flex flex-col">
                            <div>بطاقة فعالية مذكرة التفاهم</div>
                            <div>MoU Effectiveness Card</div>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">First Party</th>
                    <td class="bg-white p-2 border border-black">{{ mouEffectivenessCard.first_party_labels.join(', ')
                    }}</td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الطرف
                        الأول
                    </th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">Second Party</th>
                    <td class="bg-white p-2 border border-black">{{ mouEffectivenessCard.second_party }}</td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الطرف
                        الثاني</th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">Concerned
                        Department
                    </th>
                    <td class="bg-white p-2 border border-black">{{ mouEffectivenessCard.concerned_department }}
                    </td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">الإدارة
                        المعنية</th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">MOU Signing Date
                    </th>
                    <td class="bg-white p-2 border border-black">{{
                        getFormattedDate(mouEffectivenessCard.mou_signing_date) }}</td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">تاريخ
                        توقيع
                        المذكرة</th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">MOU End Date</th>
                    <td class="bg-white p-2 border border-black">{{
                        getFormattedDate(mouEffectivenessCard.mou_end_date) }}</td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">تاريخ
                        انتهاء المذكرة</th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>Departments/Sections</div>
                            <div>Involved in Implementing</div>
                            <div>MOU clauses</div>
                        </div>
                    </th>
                    <td class="bg-white p-2 border border-black">{{ mouEffectivenessCard.mou_clauses }}</td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الإدارات / الأقسام المشاركة</div>
                            <div>في تنفيذ بنود المذكرة</div>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th class="t-column p-2 text-black border border-black whitespace-nowrap">Coordinators Name
                    </th>
                    <td class="bg-white border-0 p-0">
                        <table class="w-full border-0 border-collapse m-0">
                            <thead>
                                <tr class="border-b border-black">
                                    <th class="t-column p-1 text-center border-r border-black whitespace-nowrap">
                                        <div class="flex flex-col">
                                            <div>الطرف الثاني</div>
                                            <div>Second Party</div>
                                        </div>
                                    </th>
                                    <th class="t-column p-1 text-center whitespace-nowrap">
                                        <div class="flex flex-col">
                                            <div>الطرف الأول</div>
                                            <div>First Party</div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="text-center">
                                    <td class="p-1 border-r border-black">{{
                                        mouEffectivenessCard.coordinator_second_party
                                    }}
                                    </td>
                                    <td class="p-1">{{ mouEffectivenessCard.coordinator_first_party }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <th class="t-column p-2 text-black border border-black text-right whitespace-nowrap">أسماء
                        المنسقين</th>
                </tr>
            </tbody>
        </table>
        <table class="mt-8 w-full border border-black border-collapse">
            <thead>
                <tr>
                    <th colspan="5" class="font-bold text-center t-heading text-black p-3 border border-black">
                        <div class="flex flex-col">
                            <div>اجتماعات اللجنة المشتركة</div>
                            <div>Joint Committee Meetings</div>
                        </div>
                    </th>
                </tr>
                <tr class="border-b border-black">
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>سنة</div>
                            <div>Year</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الربع الرابع</div>
                            <div>Q4</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الربع الثالث</div>
                            <div>Q3</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الربع الثاني</div>
                            <div>Q2</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الربع الأول</div>
                            <div>Q1</div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in mouEffectivenessCard.mouJointCommitteeMeetings" :key="index"
                    class="text-center">
                    <td class="p-1 border border-black">{{ item.year }}</td>
                    <td class="p-1 border border-black text-left">{{ item.q4 }}</td>
                    <td class="p-1 border border-black text-left">{{ item.q3 }}</td>
                    <td class="p-1 border border-black text-left">{{ item.q2 }}</td>
                    <td class="p-1 border border-black text-left">{{ item.q1 }}</td>
                </tr>
            </tbody>
        </table>
        <table class="mt-8 w-full border border-black border-collapse">
            <thead>
                <tr>
                    <th colspan="4" class="font-bold text-center t-heading text-black p-3 border border-black">
                        <div class="flex flex-col">
                            <div>المخرجات الرئيسية لمذكره التفاهم</div>
                            <div>Main Outcomes for MOU</div>
                        </div>
                    </th>
                </tr>
                <tr class="border-b border-black">
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>% الفعلي إلى المتوقع</div>
                            <div>Actual to Expected %</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>الفعلي</div>
                            <div>Actual</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>المتوقع</div>
                            <div>Expected</div>
                        </div>
                    </th>
                    <th class="t-column p-1 text-center border border-black whitespace-nowrap">
                        <div class="flex flex-col">
                            <div>المخرجات الرئيسية</div>
                            <div>Main Outcomes</div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in mouEffectivenessCard.moUOutcomes" :key="index" class="text-center">
                    <td class="p-1 border border-black">{{ getPercentage(item.actual, item.expected) }}</td>
                    <td class="p-1 border border-black">{{ item.actual }}</td>
                    <td class="p-1 border border-black">{{ item.expected }}</td>
                    <td class="p-1 border border-black">
                        <div class="flex flex-col">
                            <div>{{ getArabicText(item.name) }}</div>
                            <div>{{ item.name }}</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { formattedDate } from "../../../helpers/utils";
export default {
    name: "mou-effectiveness-card-view",
    props: ["mouEffectivenessCard"],
    methods: {
        getFormattedDate(date) {
            return formattedDate(date);
        },
        getPercentage(x, y) {
            if (!y || isNaN(x) || isNaN(y)) return "";
            return `${parseFloat(((x / y) * 100).toFixed(2))} %`;
        },
        getArabicText(engText) {
            if (engText == 'Graduates Employment') {
                return "توظيف الخريجين";
            } else if (engText == 'Training while studying') {
                return "التدريب أثناء الدراسة";
            } else if (engText == 'Training ends with Employment') {
                return "التدريب بغرض التوظيف";
            } else if (engText == 'Participation in Seminars, Workshops and Conferences') {
                return "المشاركة في الندوات وورش العمل والمؤتمرات";
            } else if (engText == 'Participation in Activities & Events') {
                return "المشاركة في الفعاليات والمناسبات";
            } else if (engText == 'Others') {
                return "أخرى";
            } else {
                return "";
            }
        },
    },
}
</script>

<style lang="scss" scoped>
table td {
    height: 40px;
}

.t-heading {
    background-color: #2E5F7F;
}

.t-column {
    background-color: #BDD3EC;
}
</style>